import { defineMessages } from 'react-intl';

export const scope = 'data_source';

export default defineMessages({
    connection_error: {
        id: `${scope}.connection_error`,
        defaultMessage: 'Connection failed. Please try again.',
    },
    project_check: {
        id: `${scope}.project_check`,
        defaultMessage: 'Please select a project and try again.',
    },
    integration_error: {
        id: `${scope}.integration_error`,
        defaultMessage: 'Failed to add connection. Please try again.',
    },
    integration_data_error: {
        id: `${scope}.integration_data_error`,
        defaultMessage: 'Failed to add integration. No data available.',
    },
    connection_success: {
        id: `${scope}.connection_success`,
        defaultMessage: 'Connector saved successfully.',
    },
    pop_up_block: {
        id: `${scope}.pop_up_block`,
        defaultMessage: 'A pop-up was blocked. Please allow pop-ups for this site.',
    },
    oauth_timeout: {
        id: `${scope}.oauth_timeout`,
        defaultMessage: 'OAuth process timed out. Please try again.',
    },
    oauth_cancel: {
        id: `${scope}.oauth_cancel`,
        defaultMessage: 'OAuth process was cancelled.',
    },
    unexpected_error: {
        id: `${scope}.unexpected_error`,
        defaultMessage: 'An unexpected error occurred. Please try again.',
    },
    invalid_source: {
        id: `${scope}.invalid_source`,
        defaultMessage: 'Invalid source data.',
    },
    delete_check: {
        id: `${scope}.delete_check`,
        defaultMessage: 'Are you sure you want to delete the source',
    },
    integration_remove: {
        id: `${scope}.integration_remove`,
        defaultMessage: 'Integration removed successfully.',
    }
});
